// extracted by mini-css-extract-plugin
export var columnHeader = "h2KSz";
export var columnHeaderHovered = "OQICU";
export var columnHeadersContainer = "s8wta";
export var emptyFirstColumn = "ddb09";
export var full = "_6d8zz";
export var resizeHandle = "RfETL";